// extracted by mini-css-extract-plugin
export default {"item":"MealsItem_item__b0a8O","description":"MealsItem_description__+127-","price":"MealsItem_price__LbqfG"};